import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LayoutDashboard, Package, Wallet, Users, Banknote, User, Home, LogOut, BarChart3, ShieldCheck, Settings, LineChart, Gift, Network, Image, FileBarChart, Globe, WalletCards, PlusCircle } from 'lucide-react';

export default function Sidebar({ isOpen, onClose }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const userLinks = [
    { path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/dashboard/deposit', icon: PlusCircle, label: 'Add Funds' },
    { path: '/dashboard/package', icon: Package, label: 'My Package' },
    { path: '/dashboard/wallet', icon: WalletCards, label: 'Wallet' },
    { path: '/dashboard/income', icon: Wallet, label: 'My Income' },
    { path: '/dashboard/team', icon: Users, label: 'My Team' },
    { path: '/dashboard/withdraw', icon: Banknote, label: 'Withdraw' },
    { path: '/dashboard/kyc', icon: ShieldCheck, label: 'KYC Verification' },
    { path: '/dashboard/profile', icon: User, label: 'Profile' },
  ];

  const adminLinks = [
    { path: '/admin', icon: Home, label: 'Overview' },
    { path: '/admin/users', icon: Users, label: 'All Users' },
    { path: '/admin/deposits', icon: PlusCircle, label: 'Deposit Requests' },
    { path: '/admin/packages', icon: Package, label: 'Packages' },
    { path: '/admin/withdrawals', icon: Banknote, label: 'Withdrawals' },
    { path: '/admin/income', icon: BarChart3, label: 'All Transactions' },
    { path: '/admin/reward', icon: Gift, label: 'Rewards' },
    { path: '/admin/team', icon: Network, label: 'Team & Business' },
    { path: '/admin/reports', icon: FileBarChart, label: 'Reports' },
    { path: '/admin/kyc', icon: ShieldCheck, label: 'KYC Verification' },
    // { path: '/admin/cms', icon: Image, label: 'CMS (Banner/News/FAQ)' },
    { path: '/admin/roi-settings', icon: Settings, label: 'ROI Settings' },
    { path: '/admin/withdrawal-settings', icon: Banknote, label: 'Withdrawal Settings' },
    // { path: '/admin/general-settings', icon: Globe, label: 'Website & Integrations' },
    { path: '/admin/wallet-management', icon: WalletCards, label: 'Wallet Management' },
  ];

  const links = user?.role === 'admin' ? adminLinks : userLinks;

  return (
    <>
      <div className={`sidebar-overlay ${isOpen ? 'open' : ''}`} onClick={onClose}></div>
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        {/* User info */}
        <div style={{ padding: '0 20px 20px', borderBottom: '1px solid var(--border-gold)', marginBottom: '12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: 44, height: 44,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, var(--primary), var(--primary-dark))',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontWeight: 700, fontSize: '1.1rem', color: '#fff', flexShrink: 0
            }}>
              {user?.name?.[0]?.toUpperCase()}
            </div>
            <div style={{ overflow: 'hidden' }}>
              <div style={{ fontWeight: 600, fontSize: '0.9rem', color: 'var(--text-white)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user?.name}</div>
              {/* Referral code stays hidden here until the user has an active
                  package — same rule as the referral box on the Dashboard —
                  so nobody can build a downline before becoming a member
                  themselves. Admins always see theirs since it's how people
                  join directly under the platform. */}
              {(user?.role === 'admin' || user?.isActive) && (
                <div style={{ fontSize: '0.75rem', color: 'var(--primary)' }}>{user?.referralCode}</div>
              )}
            </div>
          </div>
        </div>

        <p className="sidebar-section-title">{user?.role === 'admin' ? 'Admin Panel' : 'Main Menu'}</p>
        <ul className="sidebar-menu">
          {links.map(link => (
            <li className="sidebar-item" key={link.path}>
              <NavLink
                to={link.path}
                end={link.path === '/dashboard' || link.path === '/admin'}
                className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
                onClick={onClose}
              >
                <span className="icon"><link.icon size={18} /></span>
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div style={{ marginTop: 'auto', padding: '20px 24px 0', borderTop: '1px solid var(--border-gold)' }}>
          <button
            onClick={handleLogout}
            className="btn btn-outline btn-sm"
            style={{ width: '100%', marginTop: 12 }}
          >
            <LogOut size={16} style={{ verticalAlign: 'middle', marginRight: 6 }} /> Logout
          </button>
        </div>
      </aside>
    </>
  );
}